import Vue from 'vue'
import * as $alertme from '@/services/alertme'


let instaled = false;

// plugin install
const install = Vue => {
  if (instaled) {
    return; // users plugin já foi instalado
  }
  
  Object.defineProperties(Vue.prototype, {
    $alertme: {
      get() {
        return $alertme;
      },
    },
  });

  instaled = true;
};
Vue.use(install)